import { GuidedTourStep } from '../../../model/guided-tour-step';

export const generalInformationSteps: GuidedTourStep[] = [
  {
    highlightTargetId: 'markant-body',
    ignoreHighlightClick: true,
    shape: 'rectangle',
    hideBackButton: true,
  },
  {
    highlightTargetId: 'header-navigation-tab-backoffice',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section1.description.adminAreaButton' },
    hideArrow: true,
  },
  {
    highlightTargetId: 'dashboard-tile-container',
    border: 15,
    shape: 'rectangle',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section1.description.adminDashboard' },
  },
];
